var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mobile_product_description_banner"},[_c('p',{staticClass:"mobile_product_description_banner_title"},[_vm._v("新手指引")]),_c('p',{staticClass:"mobile_product_description_banner_desc"},[_vm._v("通过快速入门教程，实践案例，视频教程等各项操作指南，帮助新用户更快的了解产品的使用。")])])
}]

export { render, staticRenderFns }